<template>
  <div class="page">
     <headerPreview v-if="is_preview"></headerPreview>
    <Headers v-else ></Headers>
    <div class="con">
      <div class="suggest">
        <el-card class="box-card">
          <el-table
            :data="tableData"
            style="width: 1200px; margin-bottom: 0px"
            row-key="id"
            border
            class="custom-table1"
            :row-class-name="tableRowClassName"
          >
            <!-- <el-table-column label="序号" min-width="50" show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="width: 100%; text-align: center">
                  {{ scope.$index + 1 }}
                </div>
              </template>
            </el-table-column> -->

            <el-table-column
              prop="cname"
              align="center"
              label="城市"
              min-width="60"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            v-if="level_name !=='B'"
              prop="qname"
              align="center"
              label="区县市"
              min-width="60"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="block"
              align="center"
              label="板块/街道"
              min-width="80"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="locationname"
              align="center"
              label="地块名称"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="location"
              align="center"
              label="地块位置"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="acreagemu"
              align="center"
              label="面积（亩）"
              min-width="70"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="useyears"
              align="center"
              label="出让年限"
              min-width="80"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="usedetail"
              align="center"
              label="规划用途"
              min-width="80"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="volume"
              align="center"
              label="容积率"
              min-width="60"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="height"
              align="center"
              label="建筑高度"
              min-width="66"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="mujunshuishou" align="center" label="亩均税收（万元/亩）" min-width="106" show-overflow-tooltip> 
            </el-table-column>
            <el-table-column  prop="lowest_invest" align="center" label="投资强度（万元/公顷）" min-width="118" show-overflow-tooltip>
            </el-table-column>
            <el-table-column  prop="build_matter" align="center" label="产业类型要求" min-width="70" show-overflow-tooltip>
            </el-table-column>

            <el-table-column
              prop="status_txt"
              align="center"
              label="当前状态"
              min-width="80"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>

          <div slot="header" class="clearfix">
            <div
              style="
                font-size: 18px;
                width: 100%;
                text-align: center;
                font-weight: 600;
              "
            >
              {{ tableData[0].locationname }}
            </div>
            <div v-if=" tableData[0].contact!=null" style="
                font-size: 13px;
                width: 100%;
                margin-top: 5px;
                text-align: center;
                font-weight: 400;
                color: #333;
              ">
               （<span> 出让方联系人:{{ tableData[0].contact }}</span>
               <span style="width:5px; display:inline-block"></span>
               <span> 联系电话:{{ tableData[0].contactWay }}</span>）
            </div>

            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <div
            style="
              font-size: 18px;
              width: 100%;
              text-align: center;
              margin-top: 20px;
              margin-bottom: 30px;
              font-weight: 500;
              font-weight: 600;
            "
          >
            地块意向调查表
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="190px"
            class="survey-form"
          >
            <el-divider></el-divider>
            <el-form-item label="地块意向度" prop="intention" class="survey-row">
              <el-radio-group v-model="ruleForm.intention">
                <el-radio class="row-radio" v-for="item in intentionList" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="意向用地面积" prop="ratio" class="survey-row">
              <el-checkbox-group v-model="ruleForm.ratio">
                <el-checkbox class="row-checkbox" v-for="item in ratioList" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="对地块位置的核心偏好" prop="watch" class="survey-row">
              <el-checkbox-group v-model="ruleForm.watch" class="with-inline-input">
                <el-checkbox class="row-checkbox" v-for="item in watchlist" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
                <el-checkbox class="row-checkbox" :label="99">无特别要求，土地价格优惠即可</el-checkbox>
                <el-input class="row-inline-input" placeholder="其他" v-model="ruleForm.watchOther"></el-input>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="意向单位方面" prop="innerlayout" class="survey-row">
              <el-checkbox-group v-model="ruleForm.innerlayout" class="with-inline-input">
                <el-checkbox class="row-checkbox" v-for="item in innerlayoutlist" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
                <el-input class="row-inline-input" placeholder="其他" v-model="ruleForm.innerlayoutOther"></el-input>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="企业目前的发展阶段" prop="companyidea" class="survey-row">
              <el-checkbox-group v-model="ruleForm.companyidea">
                <el-checkbox class="row-checkbox" v-for="item in companyideaList" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="计划获取方式" prop="invest" class="survey-row">
              <el-checkbox-group v-model="ruleForm.invest">
                <el-checkbox class="row-checkbox" v-for="item in investList" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="预计总投资额(包含土地、建筑、设备等)" prop="totalInvest" class="survey-row">
              <el-checkbox-group v-model="ruleForm.totalInvest">
                <el-checkbox class="row-checkbox" v-for="item in totalInvestList" :key="item.id" :label="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="其他意见或建议" prop="otherAdvice" class="survey-row textarea-row input-align-row">
              <el-input type="textarea" v-model="ruleForm.otherAdvice" placeholder="其他"></el-input>
            </el-form-item>

            <el-form-item label="联系人" prop="contact" class="survey-row input-align-row">
              <el-input v-model="ruleForm.contact" placeholder="请输入联系人"></el-input>
            </el-form-item>

            <el-form-item label="联系方式" prop="contactWay" class="survey-row input-align-row">
              <el-input v-model="ruleForm.contactWay" placeholder="请输入联系方式"></el-input>
            </el-form-item>

            <el-form-item class="btnbox">
              <el-button class="btntijiao" type="primary" @click="onSubmit">立即创建</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  LoginedlandDetail,
  savegySuggest,
  surveyChanyeOptions,
} from "@/api/website/collect.js";

import Headers from '@/components/collect/header'
import headerPreview from '@/components/collect/headerPreview'
export default {
  components:{Headers,headerPreview},
  props: {
      is_preview: 0
    },
  data() {
    return {
      level_name:'',
      city_id: null,
      id: null,
      tableData: [
        {
          locationname: "",
        },
      ],

      //计划获取方式
      investList: [
        {
          id: 1,
          name: "购买（50年产权工业用地/厂房）",
        },
        {
          id: 2,
          name: "租赁（标准厂房/研发楼）",
        },
        {
          id: 3,
          name: "合作共建（土地作价入股等）",
        },
      ],
      //意向度条件
      intentionList: [
        {
          id: 1,
          name: "高",
        },
        {
          id: 2,
          name: "较高",
        },
        {
          id: 3,
          name: "一般",
        },
        {
          id: 4,
          name: "无",
        },
      ],
      //意向用地面积
      ratioList: [
        {
          id: 1,
          name: "10亩以下",
        },
        {
          id: 2,
          name: "10-30亩",
        },
        {
          id: 3,
          name: "30-50亩",
        },
        {
          id: 4,
          name: "50-100亩以上",
        },
        {
          id: 5,
          name: "100亩以上",
        },
      ],
      //对地块位置的核心偏好
      watchlist: [
        {
          id: 1,
          name: "靠近高速公路出入口/交通主干道",
        },
        {
          id: 2,
          name: "靠近港口/机场/铁路货运站",
        },
        {
          id: 3,
          name: "靠近现有的产业链上下游集群",
        },
        {
          id: 4,
          name: "靠近市区/便于员工通勤",
        },
      ],
      //意向单位方面
      innerlayoutlist: [
        {
          id: 1,
          name: "所属行业类别（主要业务方向）",
        },
        {
          id: 2,
          name: "新一代信息技术",
        },
        {
          id: 3,
          name: "高端装备制造",
        },
        {
          id: 4,
          name: "生物医药/大健康",
        },
        {
          id: 5,
          name: "新能源/新材料",
        },
        {
          id: 6,
          name: "现代物流",
        },
        {
          id: 7,
          name: "总部经济/研发中心",
        },
      ],
      //企业目前的发展阶段
      companyideaList: [
        {
          id: 1,
          name: "初创期（需孵化场地）",
        },
        {
          id: 2,
          name: "成长期（需扩大生产、有明确扩产计划）",
        },
        {
          id: 3,
          name: "成熟期（需设立总部/研发基地）",
        },
        {
          id: 4,
          name: "转型期（需要新设备/置换旧厂）",
        },
      ],
      totalInvestList: [
        { id: 1, name: "2000万以下" },
        { id: 2, name: "2000万-5000万" },
        { id: 3, name: "5000万-1亿" },
        { id: 4, name: "1亿-3亿" },
        { id: 5, name: "3亿以上" },
      ],

      ruleForm: {
        intention: 1, //意向度
        totalInvest: [1], //预计总投资额
        ratio: [1], //意向用地面积
        watch: [], //外部关注点
        watchOther: "", //外部关注其他
        innerlayout: [], //内部关注点
        innerlayoutOther: "", //外部关注点其他
        companyidea: [1], //企业发展阶段
        invest: [1], //计划获取方式
        otherAdvice: "", //其他建议
        contact: "", //联系人
        contactWay: "", //联系方式
      },
      rules: {
        intention: [
          { required: true, message: "请选择意向度", trigger: "change" },
        ],
        ratio: [{ required: true, type: "array", message: "请选择意向用地面积", trigger: "change" }],
        watch: [
          { required: true, message: "请选择对地块位置的核心偏好", trigger: "change" },
        ],

        innerlayout: [
          { required: true, message: "请选择意向单位方向", trigger: "change" },
        ],

        companyidea: [
          { required: true, type: "array", message: "请选择企业发展阶段", trigger: "change" },
        ],

        invest: [
          {
            required: true,
            message: "请选择计划获取方式",
            trigger: "change",
          },
        ],
        totalInvest: [
          { required: true, type: "array", message: "请选择预计总投资额", trigger: "change" },
        ],
        contact: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactWay: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
      },
    };
  },

  mounted() {
    surveyChanyeOptions({ city_id: this.city_id, did: this.id }).then((res) => {
      const data = (res && res.data) || {};
      this.intentionList = this.normalizeOptionList(data.intentionList, this.intentionList);
      this.ratioList = this.normalizeOptionList(data.ratioList, this.ratioList);
      this.watchlist = this.normalizeOptionList(data.watchList, this.watchlist);
      this.innerlayoutlist = this.normalizeOptionList(data.innerlayoutList, this.innerlayoutlist);
      this.companyideaList = this.normalizeOptionList(data.companyideaList, this.companyideaList);
      this.investList = this.normalizeOptionList(data.investList, this.investList);
      this.totalInvestList = this.normalizeOptionList(data.totalInvestList, this.totalInvestList);

      this.resetSelectionAfterOptionsSync();
    }).catch(() => {});
    this.getlandDetail();
  },
  created() {
    this.id = this.$route.params.id;
    this.city_id = this.$route.params.cityid;
  },
  methods: {
    normalizeOptionList(apiList, fallbackList) {
      if (!Array.isArray(apiList) || apiList.length === 0) return fallbackList;
      return apiList
        .filter((item) => item && item.id !== undefined && item.name !== undefined)
        .map((item) => ({
          id: Number(item.id),
          name: String(item.name),
        }));
    },
    resetSelectionAfterOptionsSync() {
      const singleIntentionIds = this.intentionList.map((item) => item.id);
      if (!singleIntentionIds.includes(this.ruleForm.intention)) {
        this.ruleForm.intention = singleIntentionIds[0] || "";
      }

      const ratioIds = this.ratioList.map((item) => item.id);
      this.ruleForm.ratio = this.ruleForm.ratio.filter((id) => ratioIds.includes(id));

      const watchIds = this.watchlist.map((item) => item.id);
      this.ruleForm.watch = this.ruleForm.watch.filter((id) => watchIds.includes(id));

      const innerlayoutIds = this.innerlayoutlist.map((item) => item.id);
      this.ruleForm.innerlayout = this.ruleForm.innerlayout.filter((id) => innerlayoutIds.includes(id));

      const companyideaIds = this.companyideaList.map((item) => item.id);
      this.ruleForm.companyidea = this.ruleForm.companyidea.filter((id) => companyideaIds.includes(id));

      const investIds = this.investList.map((item) => item.id);
      this.ruleForm.invest = this.ruleForm.invest.filter((id) => investIds.includes(id));

      const totalInvestIds = this.totalInvestList.map((item) => item.id);
      this.ruleForm.totalInvest = this.ruleForm.totalInvest.filter((id) => totalInvestIds.includes(id));
    },
    tableRowClassName() {
      return "pointer-row"; // 为每一行添加自定义类名
    },

    getlandDetail() {
      LoginedlandDetail({ id: this.id,city_id: this.city_id}).then((res) => {
        this.tableData = [res.data.table];
        this.level_name = res.data.level_name;
      });
    },
    onSubmit() {
      const params = {
        ...this.ruleForm,
        watch: [...this.ruleForm.watch],
        innerlayout: [...this.ruleForm.innerlayout],
        companyidea: [...this.ruleForm.companyidea],
        invest: [...this.ruleForm.invest],
        totalInvest: [...this.ruleForm.totalInvest],
      };
      params.did = this.id;
      params.city_id = this.city_id;

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          params.ratio = JSON.stringify(params.ratio);
          params.watch = JSON.stringify(params.watch);
          params.innerlayout = JSON.stringify(params.innerlayout);
          params.companyidea = JSON.stringify(params.companyidea);
          params.invest = JSON.stringify(params.invest);
          params.totalInvest = JSON.stringify(params.totalInvest);
          console.log("params", params);

          savegySuggest(params).then((res) => {
            if (res.code === 1) {
              this.$message.success("提交成功");
            }

            this.$router.go(-1);
          });

          // this.$router.push('/website/collect/success')
        } else {
          this.$message.info("请按照提示将表单选择完整后提交");
          return false;
        }
      });
    },
    resetForm() {},
  },
};
</script>
<style lang="scss" scoped>
.btnbox {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.btntijiao {
  background: #c27a24;
  border-color: #c27a24;
  width: 200px;
  height: 44px;
  border-radius: 12px;
  font-size: 22px;
  line-height: 22px;
}

.custom-table1 {
  ::v-deep .el-table__header-wrapper th {
    background-color:#BD7E3B; // 设置表头颜色
    color: #ffffff; // 设置表头文字颜色
  }

  ::v-deep .el-table__header-wrapper .cell {
    padding-left: 0;
    padding-right: 0;
    padding: 0;
    text-align: center;
    font-size: 16px;
  }

  ::v-deep .el-table__body-wrapper .cell {
    padding-left: 0;
    padding-right: 0;
    font-size: 15px;
  }
  ::v-deep .el-table__body-wrapper .el-table__cell {
    padding: 10px 2px;
  }
}

.con {
  margin-top: 30px;
  margin-bottom: 120px;
}

.page {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .con {
    display: flex;
    justify-content: center;
  }
  .suggest {
    text-align: left;
    width: 1200px;
  }
}

::v-deep .el-table__body-wrapper .cell {
  font-weight:bold;
  font-size:14px;
}

::v-deep .el-form-item__label {
  font-weight: bold;
  color: #4a4a4a;
  margin-right: 20px;
}

::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before {
  display: none;
}

.survey-form {
  width: 96%;
  margin: 0 auto;

  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-form-item__content {
    line-height: 36px;
  }

  ::v-deep .el-radio,
  ::v-deep .el-checkbox {
    margin-right: 26px;
    margin-bottom: 10px;
  }

  ::v-deep .el-radio__label,
  ::v-deep .el-checkbox__label {
    color: #333;
    font-size: 15px;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label,
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #a36621;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner,
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #c27a24;
    background-color: #c27a24;
  }

  ::v-deep .el-radio__inner:hover,
  ::v-deep .el-checkbox__inner:hover {
    border-color: #c27a24;
  }
}

.survey-row {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 6px;
}

.with-inline-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.row-inline-input {
  width: 220px;
  margin-bottom: 10px;
}

.input-align-row {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
  }

  ::v-deep .el-input,
  ::v-deep .el-textarea {
    width: 100%;
  }
}

.textarea-row ::v-deep .el-textarea .el-textarea__inner {
  min-height: 90px !important;
  width: 100%;
  border-radius: 10px;
  background: #fafafa;
}

::v-deep .el-table__body-wrapper .el-table__cell {
  color:#000;
  padding:10px 2px;
  font-size:15px;
}
 /*鼠标移入某行时的背景色*/
.el-table__row  tr:hover > td {
   background-color: #92cbf1;
}

::v-deep .el-table .el-table__cell {
  padding:4px  0;
}

</style>